/** @jsxImportSource @emotion/react */
import type { ReactNode } from "react";
import ReactMarkdown from "react-markdown";

import type { Theme } from "src/theme";

const styles = ({ gridUnit }: Theme) => ({
  marginTop: gridUnit * 5,
  marginBottom: gridUnit * 5,
  width: "100%",
  minHeight: gridUnit * 65,
  overflowY: "auto" as const,
  boxSizing: "border-box" as const,
  lineHeight: `${gridUnit * 8}px`,
  p: {
    fontSize: gridUnit * 4,
    lineHeight: `${gridUnit * 6}px`,
    margin: 0
  }
});
export const HelpInstruction = (props: { text: string }): ReactNode => (
  <div css={styles}>
    <ReactMarkdown>{props.text}</ReactMarkdown>
  </div>
);
